// extracted by mini-css-extract-plugin
module.exports = {"DisclosurePanel":"Disclosure_DisclosurePanel__3NyMq","DisclosurePanelOpened":"Disclosure_DisclosurePanelOpened__1CAxO"};